export enum CardOperationType {
  Sellable = 'Sellable',
  Usable = 'Usable'
}
